/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Editdescription1Inputs */

const he_account_reviews_editdescription1 = /** @type {(inputs: Account_Reviews_Editdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדכן את הביקורת שלך עבור מוצר זה`)
};

const en_account_reviews_editdescription1 = /** @type {(inputs: Account_Reviews_Editdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your review for this product`)
};

/**
* | output |
* | --- |
* | "Update your review for this product" |
*
* @param {Account_Reviews_Editdescription1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_editdescription1 = /** @type {((inputs?: Account_Reviews_Editdescription1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Editdescription1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_editdescription1(inputs)
	return en_account_reviews_editdescription1(inputs)
});
export { account_reviews_editdescription1 as "account_reviews_editDescription" }